import { z } from "zod";

const simNao = z.enum(["S", "N"]);

// Paridade com as diretivas dc* do legado: só gatilho e descrição são
// dc-not-empty. Todo o resto do formulário (portal/navegador/push/e-mail/
// documentação) não tem validação nenhuma no template original — os
// checkboxes seInterno/seExibir/sePortal/seEmail/sePush inclusive. Por isso
// ficam `.nullish()` (mesmo motivo do D14 em instituicao/formSchema.ts):
// exigir valor aqui bloquearia a edição de registros antigos sem esse campo
// gravado, sem nenhum jeito visível de corrigir.
export const layoutNotificacaoSchema = z.object({
  id: z.number().optional(),
  gatilho: z.string().min(1, "Informe o gatilho."),
  descricao: z.string().min(1, "Informe a descrição."),
  seInterno: simNao.nullish(),
  seExibir: simNao.nullish(),
  sePortal: simNao.nullish(),
  seEmail: simNao.nullish(),
  sePush: simNao.nullish(),
  tituloPortal: z.string().optional(),
  corpoPortal: z.string().optional(),
  tituloNavegador: z.string().optional(),
  corpoNavegador: z.string().optional(),
  urlWeb: z.string().optional(),
  tituloPush: z.string().optional(),
  corpoPush: z.string().optional(),
  urlApp: z.string().optional(),
  assuntoEmail: z.string().optional(),
  emailRemetente: z.string().optional(),
  corpoEmail: z.string().optional(),
  idTemplate: z.string().optional(),
  documentacao: z.string().optional(),
});

export type LayoutNotificacaoFormValues = z.infer<typeof layoutNotificacaoSchema>;
